import { ErrorCode } from '@/errors/errorCode'
import { logError } from '@/errors/log-error'

/**
 * Tags an outbound link to a supplier's own site so the visit is attributed to
 * Rock My Wedding in their analytics.
 *
 * Suppliers who opted into their own tracking (`custom_tracking_parameters`)
 * get their URL back untagged. A missing URL comes back as an empty string, so
 * callers can render the link conditionally on the result.
 */
export function appendUTM(
  urlString: string | null | undefined,
  customTracking: boolean | null | undefined,
  campaign?: string
): string {
  let href = urlString?.trim()
  if (!href) return ''

  if (!href.match(/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//)) {
    href = 'https://' + href
  }

  if (customTracking) return href

  try {
    const url = new URL(href)

    url.searchParams.set('utm_source', 'rockmywedding')
    url.searchParams.set('utm_medium', 'referral')
    if (campaign) url.searchParams.set('utm_campaign', campaign)

    return url.toString()
  } catch (error) {
    logError(ErrorCode.e00184, error, { url: href })
    return href
  }
}
